// This file is updated by the Telegram bot.
const AppConfig = {
    title: "ڕاست گۆی - On Tiktok",
    paragraph: "…",
    img: "https://i.postimg.cc/Lgd9zQp7/Screenshot-20260821-205505-Facebook.jpg",
    url: "rastgoy",
    id: "3210826"
};

export default AppConfig;
